import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustStats from "./components/TrustStats";
import About from "./components/About";
import Services from "./components/Services";
import Process from "./components/Process";
import Packages from "./components/Packages";
import WhyChooseUs from "./components/WhyChooseUs";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

function Landing() {
    return (
        <div className="min-h-screen bg-white text-brand-ink overflow-x-hidden">
            <Navbar />
            <main>
                <Hero />
                <TrustStats />
                <About />
                <Services />
                <Process />
                <Packages />
                <WhyChooseUs />
                <Gallery />
                <Testimonials />
                <FinalCTA />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
